import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckIcon } from "lucide-react";
import { clinic } from "../../data/clinic";
import { parseDateKey } from "../../utils/slots";
import { formatLongDate, formatTime } from "../../utils/format";
import type { Appointment, Service } from "../../types/booking";
interface BookingConfirmationProps {
  appointment: Appointment;
  service: Service;
}
export function BookingConfirmation({
  appointment,
  service
}: BookingConfirmationProps) {
  const reminders = [service.requiresPrescription ? "Votre ordonnance et votre carte Vitale" : "Votre carte Vitale", "Une tenue confortable", "Arrivez 5 minutes avant l'heure du rendez-vous"];
  return <motion.div initial={{
    opacity: 0,
    scale: 0.96
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.25,
    ease: [0.23, 1, 0.32, 1]
  }} className="mx-auto max-w-2xl rounded-3xl border border-line bg-white p-8 text-center md:p-12" data-id="element-52" data-mp="1pnz59nuhsx0a">
      <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-success/10 text-success" data-id="element-53" data-mp="vuvrtfhi5h4v">
        <CheckIcon className="h-7 w-7" aria-hidden="true" data-id="element-54" data-mp="10sxaw0exhggc" />
      </span>
      <h2 className="mt-6 text-2xl font-semibold text-ink md:text-3xl" data-id="element-55" data-mp="14t7rs849dr9z">Rendez-vous confirmé</h2>
      <p className="mt-3 text-base text-muted" data-id="element-56" data-mp="19m0wwx3n31ml">
        {service.name} le{" "}
        <span className="font-medium text-ink" data-id="element-57" data-mp="1eklm81hcs0w9">
          {formatLongDate(parseDateKey(appointment.dateKey)).toLowerCase()} à {formatTime(appointment.time)}
        </span>
        <br data-id="element-58" data-mp="1jkzxdse93qyi" />
        {clinic.street}, {clinic.city}
      </p>

      <div className="mx-auto mt-8 max-w-md rounded-2xl bg-surface p-6 text-left" data-id="element-59" data-mp="1ojku3huansi7">
        <h3 className="text-sm font-semibold text-ink" data-id="element-60" data-mp="1sitp0q12lwfc">À prévoir</h3>
        <ul className="mt-3 list-disc space-y-1.5 pl-5 text-sm text-muted" data-id="element-61" data-mp="3q9wb31u5djf4">
          {reminders.map(r => <li key={r} data-id="element-62" data-mp="3uaomo1qhs0ek">{r}</li>)}
        </ul>
      </div>

      <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row" data-id="element-63" data-mp="3ud1bmyuo3b14">
        <Link to="/mon-espace" className="rounded-full bg-brand px-6 py-3 text-sm font-medium text-white transition-colors duration-150 hover:bg-brand-dark" data-id="element-64" data-mp="11gzswanoll8o">
          Voir mes rendez-vous
        </Link>
        <Link to="/" className="rounded-full border border-line px-6 py-3 text-sm font-medium text-ink transition-colors duration-150 hover:border-brand hover:text-brand" data-id="element-65" data-mp="16fue1j94flvy">
          Retour à l'accueil
        </Link>
      </div>
    </motion.div>;
}